import { instance4 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { isEmpty } from "lodash";

export const RESET_STATE_MASTER_GUDANG = {
  id: "",
  name: "",
  id_unit: null,
  unit: "Pilih Unit",
  id_gudang: 0,
  status_jual: true,
};

export const urlGet = LIST_URL_WAREHOUSE.masterGudangPBF.get;
export const urlUpdate = LIST_URL_WAREHOUSE.masterGudangPBF.update;
export const urlCreate = LIST_URL_WAREHOUSE.masterGudangPBF.add;
export const urlDelete = LIST_URL_WAREHOUSE.masterGudangPBF.delete;

export const STYLE_MASTER_GUDANG = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const getAllMasterGudang = async () => {
  try {
    const api = await instance4.get(urlGet);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteMasterGudangById = async (id) => {
  try {
    await instance4.post(urlDelete, {
      id,
    });
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA GUDANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_gudang",
    disablePadding: false,
    label: "GUDANG UTAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "namaUnit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_jual",
    disablePadding: false,
    label: "STATUS JUAL",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
